import GroupTable from "./tables/GroupTable";
import DeviceTable from "./tables/DeviceTable";

export default function Devices({ session }) {
  return (
    <div >
      <div className="card-header">
        <h1>Devices</h1>
      </div>
      <DeviceTable isAdmin={Boolean(session?.isAdmin)} />
      <div className="card-header">
        <h1>Groups</h1>
      </div>
      <GroupTable isAdmin={Boolean(session?.isAdmin)} />
    </div>
  );
}
